export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";